import { h } from "preact";
import { useState } from "preact/hooks";


export default function CGU() {

	return (<div style="padding: 30px"> <p align="center" style='margin-bottom:30.0pt;text-align:center'><b><span
		style='font-size:20.0pt;font-family:"Arial";mso-fareast-font-family:
"Arial";text-transform:uppercase;mso-fareast-language:FR'>ANNEXE CGU
		BKEYS</span></b></p>

		<p style='margin-bottom:30.0pt;text-align:justify'><b><span
			style='font-size:14.0pt;font-family:"Arial";mso-fareast-font-family:
"Arial";text-transform:uppercase;mso-fareast-language:FR'>INFORMATIONS
			CONCERNANT L'<span style='mso-font-kerning:18.0pt'>UTILISATION DES COOKIES</span></span></b></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Lors de la
			consultation du Site Internet et/ou de l'Application, des informations sont
			susceptibles d'être enregistrées dans des fichiers « cookies » installés dans l'ordinateur,
			tablette ou téléphone mobile de l'Utilisateur. Cette page permet de comprendre
			ce qu'est un cookie, à quoi il sert et comment on peut le paramétrer.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;mso-outline-level:2'><b><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>1. QU'EST-CE
				QU'UN COOKIE ?</span></b></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Un cookie
			est un fichier texte susceptible d'être enregistré, sous réserve du choix de
			l'Utilisateur, dans un espace dédié du disque dur de votre terminal, à
			l'occasion de la consultation d'un service en ligne grâce au logiciel de
			navigation de l'Utilisateur.<br />
			Un fichier cookie permet à son émetteur d'identifier le terminal dans lequel il
			est enregistré, pendant la durée de validité du cookie.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;mso-outline-level:2'><b><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>2. A QUOI
				SERVENT LES COOKIES EMIS SUR LE SITE ET/OU L'APPLICATION ?</span></b></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Les cookies
			utilisés sur le Site et/ou l'Application permettent d'identifier les services
			et rubriques que l'Utilisateur a visités, et plus généralement son comportement
			en matière de visites.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'><br />
			Ces informations sont utiles pour mieux personnaliser les services, contenus,
			offres et bannières qui apparaissent sur le Site et/ou l'Application et
			facilitent la navigation de l'Utilisateur sur le Site et/ou l'Application.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'><br />
			Des cookies sont également nécessaires au bon fonctionnement de certains
			services ou encore pour mesurer leur audience.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'><br />
			Des cookies sont également susceptibles d'être inclus dans les espaces
			publicitaires du Site et/ou de l'Application. Certaines informations non <span
			>identifiantes</span> peuvent être adressées à des tiers pour leur
			permettre d'adapter leurs contenus.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Toutes les
			données collectées relatives à l'utilisation des Services, du Site Internet
			et/ou de l'Application sont traitées par BKEYS et les destinataires indiquées à
			l'Article 2.1.4 des CGU situés dans et hors de l'Union Européenne notamment
			dans le but d'exécuter et fournir les Services, et ce dans le respect des
			règles prévues par la loi Informatique et libertés et le RGPD. Ces données
			seront traitées aux fins d'effectuer un suivi sur le Site et/ou l'Application,
			conformément aux stipulations ci-après.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>L'accès ou
			l'utilisation de tout ou partie des Services implique l'acceptation sans restriction
			ni réserve de ces différentes technologies par l'Utilisateur.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><b><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>2.1
			Technologies utilisées</span></b></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p style='text-align:justify;text-indent:-36.0pt;
mso-list:l4 level3 lfo10'><b><span
				style='font-family:"Arial";mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>Utilisation des technologies de suivi sur le Site et
				l'Application</span></b><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span style='font-size:10.5pt;
font-family:"Arial";mso-fareast-font-family:"Arial";
mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>BKEYS
			utilise l'outil <span >Yandex.metrica</span> de <span >Yandex</span>
			(<span >Ulitsa</span> <span >Lva</span> <span
			>Tolstogo</span> 16, Moscow, <span >Russia</span>
			119021) afin d'aider <span >Bkeys</span> à comprendre comment le
			Site Internet et l'Application sont utilisés via les cookies et d'améliorer en
			conséquence leurs contenus et les campagnes marketing. </span></p>

		<p style='text-align:justify'><span
			style='font-family:"Arial";mso-fareast-font-family:"Arial";
mso-fareast-language:FR'></span></p>

		<p style='text-align:justify;text-indent:-36.0pt;
mso-list:l0 level3 lfo8'>><b><span
				style='font-family:"Arial";mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>Utilisation des technologies de suivi sur l'Application</span></b><span
				style='font-family:"Arial";mso-fareast-font-family:"Arial";
mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p ><span ><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Bkeys</span></span><span
				style='font-family:"Arial";mso-fareast-font-family:"Arial";
mso-fareast-language:FR'> utilise : le programme d'analyse <span >Sentry</span>,
				développé par <span >Functional</span> Software, <span
				>Inc</span> (132 Hawthorne Street San Francisco, CA 94107, USA). <span
				>Bkeys</span> collecte des données concernant l'utilisation de
				l'Application, notamment en ce qui concerne les pannes et les bugs du système.
				Les informations sur l'appareil utilisé ou la version de l'Application
				installée, ainsi que d'autres informations seront utilisées afin d'aider à
				corriger les bugs, principalement en ce qui concerne le logiciel et le matériel
				de l'Utilisateur. </span></p>

		<p ><span style='font-family:"Arial",serif;mso-fareast-font-family:
"Arial";mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><b><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>2.2
			Connexion via les réseaux sociaux (Facebook <span >Connect</span>
			et Google +)</span></b></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Les
			fonctions Facebook <span >Connect</span> et Connexion via Google +
			permettent aux Utilisateurs de se connecter au Site et/ou à l'Application avec
			leurs comptes Facebook ou Google +.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Lorsque les
			Utilisateurs se connectent au Site et/ou à l'Application avec leurs comptes
			Facebook ou Google +, <span >Bkeys</span> peut accéder à certaines
			informations que vous avez renseignées sur Facebook ou Google +, afin de leur
			offrir une expérience personnalisée et sociale.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Une
			autorisation d'accéder à leurs données de profil (profil, contacts,
			coordonnées, etc.) et de partager leurs activités avec Facebook ou Google +,
			leur sera demandée.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>L'accès par <span
			>Bkeys</span> aux données de Facebook ou de Google + et
			l'utilisation qui en est faite sont limitées, notamment <span >Bkeys</span>
			n'utilise que les données strictement nécessaires pour exploiter l'Application.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>L'Utilisateur
			est informé, via l'Application, des données utilisées et la façon dont elles
			sont utilisées, affichées, partagées ou transférées.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Si
			l'Utilisateur se connecte au Site et/ou à l'Application en utilisant ses
			identifiants Facebook ou Google + et que ses amis connectent également leur
			compte au Site et/ou à l'Application, ils sauront que l'Utilisateur dispose
			d'un compte chez la <span >Bkeys</span>, sauf si celui-ci a choisi
			de ne pas être visible pour ses amis sur d'autres sites. L'Utilisateur peut
			décider à quel type d'informations ses amis peuvent avoir accès en paramétrant
			son compte dans la section Applications du site Facebook.</span></p>

		<p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;mso-outline-level:2'><b><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>2.1. Les
				cookies émis par <span >Bkeys</span> sur le Site et/ou
				l'Application :</span></b></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Lorsque
			l'Utilisateur se connecte au Site et/ou à l'Application, <span >Bkeys</span>
			peut être amenée, sous réserve du choix de l'Utilisateur, à installer divers
			cookies dans son terminal permettant à <span >Bkeys</span> de
			reconnaître le navigateur du terminal de l'utilisateur pendant la durée de
			validité du cookie concerné.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>&nbsp;<br />
			Les cookies que <span >Bkeys</span> émet sont utilisés aux fins
			décrites ci-dessous, sous réserve du choix de l'Utilisateur qui résultent des
			paramètres du logiciel de navigation de l'Utilisateur utilisé lors de la visite
			du Site et/ou de l'Application.</span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Les cookies
			permettent à <span >Bkeys</span> de :</span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l9 level1 lfo3;tab-stops:list 36.0pt'><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Faciliter la
				navigation sur le Site et/ou l'Application :</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l9 level2 lfo3;tab-stops:
list 72.0pt'><span ><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>en</span></span><span
				style='font-family:"Arial";mso-fareast-font-family:"Arial";
mso-fareast-language:FR'> adaptant la présentation du Site et/ou de
				l'Application aux préférences d'affichage du terminal de l'Utilisateur (langue
				utilisée, résolution d'affichage, système d'exploitation utilisé, <span
				>etc</span>) lors de ses visites sur le Site et/ou de
				l'Application, selon les matériels et les logiciels de visualisation ou de
				lecture que le terminal de l'Utilisateur comporte.</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l9 level2 lfo3;tab-stops:
list 72.0pt'><span ><span style='font-family:"Arial";
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>en</span></span><span
				style='font-family:"Arial";mso-fareast-font-family:"Arial";
mso-fareast-language:FR'> mémorisant des informations relatives à un formulaire
				que l'Utilisateur a rempli sur le Site et/ou l'Application (inscription ou
				accès à votre compte) ou à des produits, services ou informations que
				l'Utilisateur a choisis sur le Site et/ou l'Application (service souscrit,
				contenu consulté, <span >etc</span> …).</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;'>en<span
				style=''> permettant à l'Utilisateur d'accéder à des espaces
				réservés et personnels du Site et/ou de l'Application, tels que le compte de
				l'Utilisateur, grâce à des identifiants ou des données que l'Utilisateur a
				éventuellement antérieurement confié.</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l9 level2 lfo3;tab-stops:
list 72.0pt'><span ><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>en</span></span><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'> mettant en œuvre des mesures de sécurité.</span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l9 level1 lfo3;tab-stops:list 36.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Améliorer
				les Services : ces cookies permettent d'établir des statistiques et volume de
				fréquentation et d'utilisation des divers éléments composant le Site et/ou
				l'Application (rubriques et contenus visité, parcours ...) afin d'améliorer
				l'intérêt et l'ergonomie des Services.</span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l9 level1 lfo3;tab-stops:list 36.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Adapter la
				publicité proposée sur le Site et/ou l'Application&nbsp;:</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l9 level2 lfo3;tab-stops:
list 72.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>En
				comptabilisant le nombre total de publicités affichées par <span >Bkeys</span>
				sur les espaces publicitaires, d'identifier ces publicités, le nombre
				d'utilisateurs ayant cliqué sur chaque publicité et d'établir des statistiques.
			</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l9 level2 lfo3;tab-stops:
list 72.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>En adaptant
				les espaces publicitaires aux préférences d'affichage du terminal de
				l'Utilisateur (langue utilisée, résolution d'affichage, système d'exploitation
				utilisé, <span >etc</span>), selon les matériels et les logiciels
				de visualisation ou de lecture que le terminal de l'Utilisateur comporte. </span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l9 level2 lfo3;tab-stops:
list 72.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>En adaptant
				les contenus publicitaires affichés sur le terminal de l'Utilisateur selon la
				navigation de son terminal sur le Site et/ou l'Application.</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l9 level2 lfo3;tab-stops:
list 72.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>En adaptant
				le cas échéant les contenus publicitaires affichés sur le terminal de
				l'Utilisateur en fonction des données de localisation transmises par son
				terminal avec son accord préalable.</span></p>

		<p style='margin-left:72.0pt;mso-add-space:auto;
text-align:justify;text-indent:-18.0pt;mso-list:l9 level2 lfo3;tab-stops:list 72.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>En adaptant
				les contenus publicitaires affichés sur le terminal de l'Utilisateur en
				fonction des données personnelles qu'il a fournies.</span></p>

		<p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;mso-outline-level:2'><b><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>2.2. Les
				cookies émis sur le Site et/ou l'Application par des tiers :</span></b></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>L'émission
			et l'utilisation de cookies par des tiers sont soumises aux politiques de
			protection de la vie privée de ces tiers. <span >Bkeys</span>
			informe l'utilisateur de l'objet des cookies dont elle a connaissance et des
			moyens dont l'Utilisateur dispose pour effectuer des choix à l'égard de ces
			cookies.</span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>&nbsp;<br />
			L'Utilisateur peut exercer les droits dont il dispose au titre de la réglementation
			applicable ou effectuer une réclamation directement auprès du tiers concerné.</span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l1 level1 lfo12;tab-stops:list 36.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Du fait
				d'applications de tiers intégrées au Site et/ou à l'Application. <span
				>Bkeys</span> est susceptible d'inclure sur le Site et/ou
				l'Application, des applications informatiques émanant de tiers, qui permettent
				à l'Utilisateur de partager des contenus du Site et/ou de l'Application avec
				d'autres personnes ou de faire connaître à ces autres personnes sa consultation
				ou son opinion concernant un contenu du Site et/ou de l'Application. Tel est
				notamment le cas des boutons<span > «Partager</span>», «J'aime»,
				issus de réseaux sociaux tels que «Facebook» «Twitter», «LinkedIn», etc.&nbsp;Le
				réseau social fournissant un tel bouton applicatif est susceptible d'identifier
				l'Utilisateur grâce à ce bouton, même s'il n’a pas utilisé ce bouton lors de sa
				consultation du Site et/ou de l'Application. En effet, ce type de bouton
				applicatif peut permettre au réseau social concerné de suivre la navigation de
				l'Utilisateur sur le Site et/ou l'Application, du seul fait que son compte au
				réseau social concerné était activé sur son terminal (session ouverte) durant
				sa navigation sur le Site et/ou l'Application.&nbsp;<br />
				Si l'utilisateur ne souhaite que les réseaux sociaux publient ses actions
				issues des plug-ins dans ses comptes sur les réseaux sociaux, l'Utilisateur
				doit se déconnecter de ses réseaux sociaux avant de naviguer sur le Site et/ou
				l'Application.</span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l1 level1 lfo12;tab-stops:list 36.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Via des
				contenus de tiers diffusés dans les espaces publicitaires du Site et/ou de
				l'Application. Les contenus publicitaires diffusés sur le Site et/ou
				l'Application sont susceptibles de contenir des cookies émis par des tiers :
				soit l'annonceur à l'origine du contenu publicitaire concerné, soit une société
				tierce à l'annonceur (agence conseil en communication, société de mesure
				d'audience, prestataire de publicité ciblée, etc.), qui a associé un cookie au
				contenu publicitaire d'un annonceur.&nbsp;Le cas échéant, les cookies émis par
				ces tiers peuvent leur permettre, pendant la durée de validité de ces cookies :</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l1 level2 lfo12;
tab-stops:list 72.0pt'><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>De comptabiliser le nombre d'affichages des contenus
				publicitaires diffusés via les espaces publicitaires du Site et/ou de
				l'Application, d'identifier les publicités ainsi affichées, le nombre
				d'utilisateurs ayant cliqué sur chaque publicité, leur permettant de calculer
				les sommes dues de ce fait et d'établir des statistiques.</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l1 level2 lfo12;
tab-stops:list 72.0pt'><span
			><span style='mso-fareast-font-family:
"Arial";mso-fareast-language:FR'>de</span></span><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'> reconnaître le terminal de l'Utilisateur lors de sa
				navigation ultérieure sur tout autre site ou service sur lequel ces annonceurs
				ou ces tiers émettent également des cookies et, le cas échéant, d'adapter ces
				sites et services tiers ou les publicités qu'ils diffusent, à la navigation du
				terminal de l'utilisateur.</span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l1 level1 lfo12;tab-stops:list 36.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Par la régie
				publicitaire de <span >Bkeys</span> exploitant les espaces
				publicitaires du Site et/ou de l'Application. Les espaces publicitaires du Site
				et/ou de l'Application sont susceptibles d'être exploités par la régie
				publicitaire interne de <span >Bkeys</span> et, le cas échéant, de
				contenir des cookies émis par celle-ci. Les cookies émis permettent à <span
				>Bkeys</span>, pendant la durée de validité de ces cookies :</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l1 level2 lfo12;
tab-stops:list 72.0pt'><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>de comptabiliser le nombre total de publicités
				affichées sur les espaces publicitaires du Site et/ou de l'Application,
				d'identifier ces publicités, leur nombre d'affichages respectifs, le nombre
				d'Utilisateurs ayant cliqué sur chaque publicité et, le cas échéant, les
				actions ultérieures effectuées par ces Utilisateurs sur les pages auxquelles
				mènent ces publicités, afin de calculer les sommes dues aux acteurs de la
				chaîne de diffusion publicitaire (annonceur, agence de communication, régie
				publicitaire, site/support de diffusion) et d'établir des statistiques.</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l1 level2 lfo12;
tab-stops:list 72.0pt'><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>D'adapter les espaces publicitaires de <span
				>Bkeys</span> aux préférences d'affichage du terminal de
				l'Utilisateur (langue utilisée, résolution d'affichage, système d'exploitation
				utilisé, etc.), selon les matériels et les logiciels de visualisation ou de
				lecture que son terminal comporte.</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l1 level2 lfo12;
tab-stops:list 72.0pt'><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>D'adapter les contenus publicitaires affichés sur le
				terminal de l'Utilisateur via les espaces publicitaires selon la navigation de
				son terminal sur le Site et/ou l'Application.</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l1 level2 lfo12;
tab-stops:list 72.0pt'><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>D'adapter les contenus publicitaires affichés sur le
				terminal de l'Utilisateur via les espaces publicitaires de <span >Bkeys</span>
				selon la navigation antérieure ou ultérieure de votre terminal sur des sites de
				tiers au sein desquels la régie émet également des cookies, sous réserve que
				ces cookies aient été enregistrés dans votre terminal conformément aux choix
				que vous avez exercés à l'égard de la régie.</span></p>

		<p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l1 level2 lfo12;
tab-stops:list 72.0pt'><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>D'adapter les contenus publicitaires affichés sur le
				terminal de l'Utilisateur via les espaces publicitaires de <span >Bkeys</span>
				en fonction des données de localisation (longitude et latitude) transmises par
				son terminal avec son accord préalable.</span></p>

		<p style='margin-left:72.0pt;mso-add-space:auto;
text-align:justify;text-indent:-18.0pt;mso-list:l1 level2 lfo12;tab-stops:list 72.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>D'adapter
				les contenus publicitaires affichés sur le terminal de l'Utilisateur dans les
				espaces publicitaires de <span >Bkeys</span> en fonction des
				données personnelles qu'il aurait pu fournir.</span></p>

		<p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;mso-outline-level:2'><b><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>></span></b></p>

		<p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;mso-outline-level:2'><b><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>3. DURÉE DE
				VALIDITÉ DES COOKIES</span></b></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Les cookies
			que <span >Bkeys</span> émet sont configurés pour une durée de
			validité de 13 (treize) mois.</span><span style='font-size:10.5pt;font-family:
"Arial";mso-fareast-font-family:"Arial";
mso-fareast-language:FR'></span></p>

		<p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;mso-outline-level:2'><b><span style='font-size:10.5pt;
mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>></span></b></p>

		<p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;mso-outline-level:2'><b><span style='font-size:10.5pt;
mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>4</span></b><b><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>. LES CHOIX
				DE L'UTILISATEUR CONCERNANT LES COOKIES</span></b></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Plusieurs
			possibilités sont offertes aux Utilisateurs pour gérer les cookies. Tout
			paramétrage que l'Utilisateur peut entreprendre sera susceptible de modifier sa
			navigation sur le Site et/ou le l'Application ainsi que les conditions d'accès
			à certains services nécessitant l'utilisation de cookies.</span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>></span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Si
			l'Utilisateur n’accepte pas l'enregistrement de cookies dans son terminal, ou
			s'il supprime ceux qui y sont enregistrés, il ne pourra plus bénéficier d'un
			certain nombre de fonctionnalités nécessaires pour naviguer dans certains
			espaces du Site et/ou de l'Application.</span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>></span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Tel serait
			le cas si l'Utilisateur tente d'accéder aux contenus ou Services qui
			nécessitent à l'Utilisateur de s'identifier.</span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>></span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Tel serait
			également le cas lorsque <span >Bkeys</span> ou ses prestataires-
			ne pourraient pas reconnaître, à des fins de compatibilité technique, le type
			de navigateur utilisé par le terminal de l'Utilisateur, ses paramètres de
			langue et d'affichage ou le pays depuis lequel son terminal semble connecté à
			Internet.</span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>></span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Le cas
			échéant, <span >Bkeys</span> décline toute responsabilité pour les
			conséquences liées au fonctionnement dégradé de ses services résultant de
			l'impossibilité pour <span >Bkeys</span> d'enregistrer ou de
			consulter les cookies nécessaires à leur fonctionnement et que l'Utilisateur
			aurait refusés ou supprimés.</span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>L'Utilisateur
			peut faire le choix à tout moment d'exprimer et de modifier ses souhaits en
			matière de cookies, par les moyens décrits ci-dessous.</span></p>

		<p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;mso-outline-level:2'><b><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>4.1. Refuser
				un cookie par l'intermédiaire du logiciel de navigation de l'Utilisateur</span></b></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>L'Utilisateur
			peut configurer sont logiciel de navigation de manière à ce que des cookies
			soient enregistrés dans son terminal ou, au contraire, qu'ils soient rejetés,
			soit systématiquement, soit selon leur émetteur. L'Utilisateur peut également
			configurer son logiciel de navigation de manière à ce que l'acceptation ou le
			refus des cookies lui soient proposés ponctuellement, avant qu'un cookie soit
			susceptible d'être enregistré dans son terminal.</span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>></span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Pour la
			gestion des cookies et des choix de l'Utilisateur, la configuration de chaque
			navigateur est différente. Elle est décrite dans le menu d'aide du navigateur
			de l'Utilisateur, qui lui permettra de savoir de quelle manière modifier ses
			souhaits en matière de cookies.</span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>></span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Pour plus
			d'information :&nbsp;</span><a
				href="http://www.cnil.fr/vos-droits/vos-traces/les-cookies/conseils-aux-internautes/"><span
					style='mso-fareast-font-family:"Arial";
color:windowtext;mso-fareast-language:FR'>http://www.cnil.fr/vos-droits/vos-traces/les-cookies/conseils-aux-internautes/</span></a><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>></span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Par exemple
			:</span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l6 level1 lfo14;tab-stops:list 36.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Pour
				Internet Explorer :&nbsp;</span><a
					href="http://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies"><span
						style='mso-fareast-font-family:"Arial";
color:windowtext;mso-fareast-language:FR'>http://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies</span></a><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'></span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l6 level1 lfo14;tab-stops:list 36.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Pour Firefox
				:&nbsp;</span><a
					href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies-preferences"><span
						style='mso-fareast-font-family:"Arial";
color:windowtext;mso-fareast-language:FR'>https://support.mozilla.org/fr/kb/activer-desactiver-cookies-preferences</span></a><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'></span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l6 level1 lfo14;tab-stops:list 36.0pt'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Pour Safari
				:&nbsp;</span><a href="https://www.apple.com/legal/privacy/fr-ww/cookies/"><span
					style='mso-fareast-font-family:"Arial";
color:windowtext;mso-fareast-language:FR'>https://www.apple.com/legal/privacy/fr-ww/cookies/</span></a><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'></span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l6 level1 lfo14;tab-stops:list 36.0pt'><span ><span style='font-family:
"Arial";mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>Etc</span></span><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'> …</span></p>

		<p style='text-align:justify'><span
			style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>></span></p>

		<p style='text-align:justify'><span
			style='mso-fareast-font-family:"Arial";
mso-ansi-language:EN-US;mso-fareast-language:FR'>Les cookies « Flash »© de
			«Adobe Flash Player»™</span></p>

		<p style='text-align:justify'><span ><span
			style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>«Adobe</span></span><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'> Flash
				Player»™ est une application informatique qui permet le développement rapide
				des contenus dynamiques utilisant le langage informatique «Flash». Flash (et
				les applications de même type) mémorise les paramètres, les préférences et
				l'utilisation de ces contenus grâce à une technologie similaire aux cookies.
				Toutefois,<span > «Adobe</span> Flash Player»™ gère ces informations
				et vos choix via une interface différente de celle fournie par votre logiciel
				de navigation.</span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Dans la
			mesure où le terminal de l'Utilisateur serait susceptible de visualiser des
			contenus développés avec le langage Flash, l'utilisateur est invité à accéder à
			ses outils de gestion des cookies Flash, directement depuis le&nbsp;</span><a
				href="https://www.adobe.com/fr/privacy/cookies.html"><span style='font-family:
"Arial";mso-fareast-font-family:"Arial";
color:windowtext;mso-fareast-language:FR'>https://www.adobe.com/fr/privacy/cookies.html</span></a><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>></span></p>

		<p style='text-align:justify'><b><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>4.2. Refuser
			un cookie publicitaire</span></b></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>></span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>L'Utilisateur
			peut gérer l'utilisation et l'exploitation des cookies en se rendant sur la
			plateforme de gestion des cookies publicitaires proposée par les professionnels
			de la publicité accessible à l'adresse :&nbsp;</span><a
				href="http://www.youronlinechoices.com/fr/controler-ses-cookies/"><span
					style='mso-fareast-font-family:"Arial";
color:windowtext;mso-fareast-language:FR'>http://www.youronlinechoices.com/fr/controler-ses-cookies/</span></a><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'>&nbsp;et en suivant les instructions qui y sont
				données. L'Utilisateur pourra ainsi connaître les entreprises inscrites à cette
				plateforme, lesquelles leur offrent la possibilité de refuser ou accepter les
				cookies utilisés par elles pour adapter à leurs informations de navigation, les
				publicités susceptibles d'être affichées.</span></p>

		<p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;mso-outline-level:2'><b><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>4.3. Refuser
				un cookie émis par un réseau social :</span></b></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>Si
			l'Utilisateur ne souhaite pas que le Site et/ou l'Application enregistre des
			cookies émis par un réseau social, l'utilisateur peut cliquer sur les liens de
			désactivation suivants qui enregistreront au sein de son navigateur un cookie
			ayant pour unique objet de les désactiver. Désactiver ces cookies empêchera
			donc toute interaction avec le ou les réseaux sociaux concernés :</span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l16 level1 lfo18'><span ><span l
				style='mso-fareast-font-family:"Arial";
mso-ansi-language:EN-US;mso-fareast-language:FR'>FACEBOOK :</span></span><span
				l style='mso-fareast-font-family:
"Arial";mso-ansi-language:EN-US;mso-fareast-language:FR'>&nbsp;</span><a
				href="https://fr-fr.facebook.com/policies/cookies/"><span l
					style='mso-fareast-font-family:"Arial";
color:windowtext;mso-ansi-language:EN-US;mso-fareast-language:FR'>https://fr-fr.facebook.com/policies/cookies/</span></a><span
				l style='mso-fareast-font-family:
"Arial";mso-ansi-language:EN-US;mso-fareast-language:FR'></span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l16 level1 lfo18'><span ><span l
				style='mso-fareast-font-family:"Arial";
mso-ansi-language:EN-US;mso-fareast-language:FR'>TWITTER :</span></span><span
				l style='mso-fareast-font-family:
"Arial";mso-ansi-language:EN-US;mso-fareast-language:FR'>&nbsp;</span><a
				href="https://support.twitter.com/articles/20171379-twitter-prend-en-charge-la-desactivation-du-suivi-dnt"><span
					l style='mso-fareast-font-family:
"Arial";color:windowtext;mso-ansi-language:EN-US;mso-fareast-language:
FR'>https://support.twitter.com/articles/20171379-twitter-prend-en-charge-la-desactivation-du-suivi-dnt#</span></a><span
				l style='mso-fareast-font-family:
"Arial";mso-ansi-language:EN-US;mso-fareast-language:FR'></span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l16 level1 lfo18'><span l style='
mso-fareast-font-family:"Arial";mso-ansi-language:EN-US;mso-fareast-language:
FR'>GOOGLE <span >+ :</span>&nbsp;</span><a
				href="https://support.google.com/accounts/answer/61416?hl=fr"><span l
					style='mso-fareast-font-family:"Arial";
color:windowtext;mso-ansi-language:EN-US;mso-fareast-language:FR'>https://support.google.com/accounts/answer/61416?hl=fr</span></a><span
				l style='mso-fareast-font-family:
"Arial";mso-ansi-language:EN-US;mso-fareast-language:FR'></span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l16 level1 lfo18'><span ><span l
				style='mso-fareast-font-family:"Arial";
mso-ansi-language:EN-US;mso-fareast-language:FR'>LINKEDIN :</span></span><span
				l style='mso-fareast-font-family:
"Arial";mso-ansi-language:EN-US;mso-fareast-language:FR'>&nbsp;</span><a
				href="http://www.linkedin.com/legal/cookie-policy"><span l
					style='mso-fareast-font-family:"Arial";
color:windowtext;mso-ansi-language:EN-US;mso-fareast-language:FR'>http://www.linkedin.com/legal/cookie-policy</span></a><span
				l style='mso-fareast-font-family:
"Arial";mso-ansi-language:EN-US;mso-fareast-language:FR'></span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l16 level1 lfo18'><span ><span l
				style='mso-fareast-font-family:"Arial";
mso-ansi-language:EN-US;mso-fareast-language:FR'>YAHOO :</span></span><span
				l style='mso-fareast-font-family:
"Arial";mso-ansi-language:EN-US;mso-fareast-language:FR'>&nbsp;</span><a
				href="https://info.yahoo.com/privacy/us/yahoo/cookies/"><span l
					style='mso-fareast-font-family:"Arial";
color:windowtext;mso-ansi-language:EN-US;mso-fareast-language:FR'>https://info.yahoo.com/privacy/us/yahoo/cookies/</span></a><span
				l style='mso-fareast-font-family:
"Arial";mso-ansi-language:EN-US;mso-fareast-language:FR'></span></p>

		<p style='text-align:justify;text-indent:-18.0pt;
mso-list:l16 level1 lfo18'><span ><span l
				style='mso-fareast-font-family:"Arial";
mso-ansi-language:EN-US;mso-fareast-language:FR'>YOUTUBE :</span></span><span
				l style='mso-fareast-font-family:
"Arial";mso-ansi-language:EN-US;mso-fareast-language:FR'>&nbsp;</span><a
				href="https://support.google.com/accounts/answer/61416?hl=fr"><span l
					style='mso-fareast-font-family:"Arial";
color:windowtext;mso-ansi-language:EN-US;mso-fareast-language:FR'>https://support.google.com/accounts/answer/61416?hl=fr</span></a><span
				l style='mso-fareast-font-family:
"Arial";mso-ansi-language:EN-US;mso-fareast-language:FR'></span></p>

		<p style='text-align:justify'><span l
			style='mso-fareast-font-family:"Arial";
mso-ansi-language:EN-US;mso-fareast-language:FR'>></span></p>

		<p style='text-align:justify'><span style='
mso-fareast-font-family:"Arial";mso-fareast-language:FR'>En savoir
			plus sur les cookies&nbsp;</span><a
				href="https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser"><span
					style='mso-fareast-font-family:"Arial";
color:windowtext;mso-fareast-language:FR'>https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser</span></a><span
				style='mso-fareast-font-family:"Arial";
mso-fareast-language:FR'></span></p>
	</div>)
}